import { Typography } from "@mui/material";
import styled from "styled-components";

export const StyledLine = styled.div`
  height: 0px;
  border: 1px solid #404252;
  flex: none;
  display: block;
  flex: 2;
  margin: 0;
  min-width: 10px;
  @media (max-width: 720px) {
    display: none;
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 16px;
  /* padding: 0px 16px; */

  @media (max-width: 720px) {
    display: flex;
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
`;
type OwnerState = {
  fontWeight?: number;
  color?: string;
  fontSize?: number;
  align?: string;
  disabled?: boolean;
  minWidth?: string;
};

export const StyledTypography = styled(Typography)<{ ownerState: OwnerState }>`
  && {
    font-style: normal;
    font-size: ${(props) => props.ownerState?.fontSize || 14}px;
    line-height: 20px;
    font-weight: ${(props) => props.ownerState?.fontWeight || 400};
    color: ${(props) => props.ownerState?.color || "inherit"};
    padding-inline: 5px;
    text-align: ${(props) => props.ownerState?.align || "left"};
    opacity: ${(props) => (props.ownerState?.disabled ? 0.5 : 1)};
    min-width: ${(props) => props.ownerState?.minWidth || "auto"};
  }
`;
